// extracted by mini-css-extract-plugin
export default {"root":"Menu3DotsButton_root__ZoIsW"};